module.exports = __webpack_public_path__ + "images/6d821d926748798b1c4e9d697a1a285249526cf15ef50fff64bed4025e7c3d22.svg";